(function ($) {
  'use strict';

  var BOXED_AT = 7;

  function getProduct($root) {
    var el = document.getElementById('ProductJson-' + $root.data('sectionId'));
    if (!el) {
      return null;
    }
    try {
      return JSON.parse(el.innerText);
    } catch (e) {
      return null;
    }
  }

  function currentValues($root) {
    return $root.find('.selector-wrapper select').map(function () {
      return $(this).val();
    }).get();
  }

  function isAvailable(product, index, value, values) {
    var i;
    for (i = 0; i < product.variants.length; i++) {
      var v = product.variants[i];
      if (v.options[index] !== value) {
        continue;
      }
      var match = true;
      for (var j = 0; j < values.length; j++) {
        if (j !== index && values[j] !== v.options[j]) {
          match = false;
          break;
        }
      }
      if (match && v.available) {
        return true;
      }
    }
    return false;
  }

  function paint($root, product) {
    var values = currentValues($root);

    $root.find('.sm-variant').each(function () {
      var $row = $(this);
      var index = parseInt($row.attr('data-option-index'), 10);

      $row.find('.sm-variant__value').each(function () {
        var $button = $(this);
        var value = $button.attr('data-value');
        var selected = values[index] === value;

        $button.toggleClass('is-selected', selected);
        $button.toggleClass('is-sold', !isAvailable(product, index, value, values));
        $button.attr('aria-pressed', selected ? 'true' : 'false');
      });
    });
  }

  function build($root) {
    $root.find('.selector-wrapper').each(function () {
      var $wrapper = $(this);

      if ($wrapper.next('.sm-variant').length) {
        return;
      }

      var $select = $wrapper.find('select');
      var index = parseInt(($select.attr('id') || '').replace('SingleOptionSelector-', ''), 10);

      if (isNaN(index)) {
        return;
      }

      var $row = $('<div/>', {
        'class': 'sm-variant',
        'data-option-index': index,
        role: 'group',
        'aria-label': $wrapper.find('label').text()
      });

      $('<span/>', {
        'class': 'sm-variant__label',
        text: $wrapper.find('label').text()
      }).appendTo($row);

      var longest = 0;

      $select.find('option').each(function () {
        var value = $(this).attr('value');

        if (value.length > longest) {
          longest = value.length;
        }

        var $button = $('<button/>', {
          type: 'button',
          'class': 'sm-variant__value',
          'data-value': value
        });

        $('<span/>', { 'class': 'sm-variant__text', text: value }).appendTo($button);
        $button.appendTo($row);
      });

      if (longest >= BOXED_AT) {
        $row.addClass('sm-variant--boxed');
      }

      $wrapper.addClass('sm-variant-source').after($row);
    });
  }

  $(document).on('click', '.sm-variant__value', function () {
    var $button = $(this);
    var $root = $button.closest('.product-single');
    var index = parseInt($button.closest('.sm-variant').attr('data-option-index'), 10);

    $root
      .find('.selector-wrapper select')
      .eq(index)
      .val($button.attr('data-value'))
      .trigger('change');
  });

  window.smVariantPicker = {
    init: function (root) {
      var $scope = root ? $(root) : $(document);

      $scope.find('.product-single').addBack('.product-single').each(function () {
        var $root = $(this);
        var product = getProduct($root);

        if (!product) {
          return;
        }

        build($root);
        paint($root, product);

        $root
          .find('.selector-wrapper select')
          .off('change.smVariantPicker')
          .on('change.smVariantPicker', function () {
            paint($root, product);
          });
      });
    }
  };

  $(document).ready(function () {
    window.smVariantPicker.init();
  });

  document.addEventListener('shopify:section:load', function () {
    window.smVariantPicker.init();
  });
})(jQuery);